import { defineComponent as _defineComponent } from 'vue';
import { ref, inject, reactive } from "vue";
import { useAnimationFrameSize } from "@/composables/sensors/animationFrameSize";
import { useAnimationFrameThrottle } from "@/composables/throttle";
import { useDraggable } from "./composables/useDraggable.js";
export default /*#__PURE__*/ _defineComponent({
    __name: 'Draggable',
    props: {
        rootOffset: {
            type: Object,
            required: true,
        },
        preventDefault: {
            type: Boolean,
            default: true,
        },
        stopPropagation: {
            type: Boolean,
            default: true,
        },
        dragData: {
            type: Object,
            required: false,
            default: null,
        },
    },
    emits: ["mousedown", "mouseup", "move", "dragstart", "start", "stop"],
    setup(__props, { emit }) {
        const props = __props;
        let dragImg;
        const draggable = ref();
        const size = reactive(useAnimationFrameSize(draggable));
        const transform = inject("transform");
        const { throttle } = useAnimationFrameThrottle();
        const onStart = (position, event) => {
            emit("start");
            emit("mousedown", event);
            if (event.type == "dragstart") {
                dragImg = document.createElement("img");
                dragImg.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
                document.body.appendChild(dragImg);
                // I guess better than copy ?
                event.dataTransfer.effectAllowed = "link";
                try {
                    event.dataTransfer.setDragImage(dragImg, 0, 0);
                }
                catch (e) {
                    console.error(e);
                }
                if (props.dragData) {
                    event.dataTransfer.setData("text/plain", JSON.stringify(props.dragData));
                }
                emit("dragstart", event);
            }
        };
        const onMove = (position, event) => {
            if (event.type == "drag" && event.x == 0 && event.y == 0) {
                // the last drag event has no coordinate ... this is obviously a hack!
                return;
            }
            throttle(() => {
                const newPosition = {
                    unscaled: Object.assign(Object.assign({}, position), size),
                    x: (position.x - props.rootOffset.x - transform.value.x) / transform.value.k,
                    y: (position.y - props.rootOffset.y - transform.value.y) / transform.value.k,
                };
                emit("move", newPosition, event);
            });
        };
        const onEnd = (position, event) => {
            if (dragImg) {
                document.body.removeChild(dragImg);
            }
            emit("stop");
            emit("mouseup");
        };
        useDraggable(draggable, {
            preventDefault: props.preventDefault,
            stopPropagation: props.stopPropagation,
            useCapture: false,
            onStart: onStart,
            onMove: onMove,
            onEnd: onEnd,
        });
        return { __sfc: true, props, emit, dragImg, draggable, size, transform, throttle, onStart, onMove, onEnd };
    }
});
